import CrossIcon from 'assets/cross-thick-white.svg?react'
import CheckIcon from 'assets/tick-thick-white.svg?react'
import clsx from 'clsx'

import { Row } from '../../../pages/trade-events'
import classes from '../index.module.scss'

export interface EventHeaderProps {
  row: Row
}

export const EventHeader = ({ row }: EventHeaderProps) => (
  <header
    className={clsx({
      [classes.completed]: row.isCompleted,
      [classes.incomplete]: !row.isCompleted
    })}
  >
    <h5>{row.readableType}</h5>

    {row.isCompleted ? (
      <>
        <div className={clsx(classes.icon, classes.check)}>
          <CheckIcon />
        </div>
        Complete
      </>
    ) : (
      <>
        <div className={clsx(classes.icon, classes.cross)}>
          <CrossIcon />
        </div>
        Incomplete
      </>
    )}
  </header>
)
